<template>
    <div v-if="show && loaded" class="nevs-popup-container">
        <div class="nevs-popup">
            <div class="nevs-popup-text">
                <NevsSelect v-if="invoiceId === null" :nullable="true" :readonly="data.id !== null" :error="validation.invoice_id" v-model="data.invoice_id" :ajax="'select/invoices-with-customer'"
                            :label="$LANG.Get('fields.invoice')"></NevsSelect>
                <NevsSelect :readonly="true" v-model="data.payment_method_id" :ajax="'select/payment-methods'"
                            :label="$LANG.Get('fields.paymentMethod')"></NevsSelect>
                <NevsNumberField v-model="data.amount"
                                 :label="$LANG.Get('fields.amount') + ' (' + data.currency + ') :'"></NevsNumberField>
                <NevsDateField v-model="data.date" :error="validation.date"
                               :label="$LANG.Get('fields.date') + ':'"></NevsDateField>
                <div v-if="f2Status === 2 || f2Status === 4" class="payments-f2-disclaimer">{{ $LANG.Get('texts.paymentsReportingDisclaimer') }}</div>
            </div>
            <div class="nevs-popup-buttons">
                <NevsButton class="error" @click="cancelClick()"><i class="fa-solid fa-xmark"></i> {{
                        $LANG.Get('buttons.cancel')
                    }}
                </NevsButton>
                <NevsButton class="success" @click="saveClick()"><i class="fa-solid fa-check"></i> {{ $LANG.Get('buttons.ok') }}</NevsButton>
            </div>
        </div>
    </div>
</template>

<script>
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsNumberField from "@/components/nevs/NevsNumberField.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import moment from "moment";

export default {
    name: "ModalPayment",
    components: {NevsDateField, NevsNumberField, NevsSelect, NevsButton},
    props: {
        show: {
            type: Boolean,
            default: false
        },
        invoiceId: {
            type: Number,
            default: null
        },
        payment: {
            type: Object,
            default: null
        }
    },
    emits: ['done'],
    data() {
        return {
            loaded: false,
            f2Status: 0,
            data: {
                id: null,
                invoice_id: null,
                date: moment().format('YYYY-MM-DD'),
                amount: 0,
                currency: '',
                payment_method_id: null
            },
            validation: {
                invoice_id: '',
                date: ''
            }
        }
    },
    watch: {
        show() {
            this.loaded = false;
            this.f2Status = 0;
            this.data = {
                id: null,
                invoice_id: null,
                date: moment().format('YYYY-MM-DD'),
                amount: 0,
                currency: '',
                payment_method_id: null
            };
            this.validation = {invoice_id: '', date: ''};

            if (this.show) {
                if (this.payment !== null) {
                    this.data.id = this.payment.id;
                    this.data.date = this.payment.date;
                    this.data.amount = this.payment.amount;
                }
                if (this.invoiceId !== null) {
                    this.data.invoice_id = this.invoiceId;
                } else if (this.payment !== null) {
                    this.data.invoice_id = this.payment.invoice_id;
                }
                this.$nextTick(() => {
                    this.loaded = true;
                });
            }
        },
        'data.invoice_id': function () {
            if (this.data.invoice_id === null) return;
            let vm = this;
            this.$API.APICall('get', 'invoices/' + this.data.invoice_id, {}, (data, success) => {
                if (success) {
                    vm.data.payment_method_id = data.invoice.payment_method_id;
                    vm.data.currency = data.invoice.currency;
                    vm.f2Status = data.invoice.f2_status;
                    if (vm.data.id === null) {
                        vm.data.amount = data.invoice.financial_status;
                    }
                }
            });
        }
    },
    methods: {
        cancelClick() {
            this.$emit('done', false);
        },
        saveClick() {
            let success = true;
            if (this.invoiceId === null && this.data.invoice_id === null) {
                success = false;
                this.validation.invoice_id = this.$LANG.Get('labels.mandatoryField');
            } else {
                this.validation.invoice_id = '';
            }
            if (this.data.date === null) {
                success = false;
                this.validation.date = this.$LANG.Get('labels.mandatoryField');
            } else {
                this.validation.date = '';
            }
            if (!success) return;

            let vm = this;
            let action = 'post';
            let addition = '';
            if (this.data.id !== null) {
                action = 'put';
                addition = '/' + this.data.id;
            }
            let body = JSON.parse(JSON.stringify(this.data));
            if (this.invoiceId !== null) {
                body.invoice_id = this.invoiceId;
            }
            this.$API.APICall(action, 'payments' + addition, body, (data, success) => {
                if (success) {
                    vm.$emit('done', true);
                } else {
                    if (data.message === 'e-reporting failed') {
                        vm.$LOCAL_BUS.TriggerEvent('popup', {
                            text: vm.$LANG.Get('alerts.eReportingPaymentFailed'),
                            type: 'alert'
                        });
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                }
            });
        }
    }
}
</script>

<style scoped lang="scss">
@use '../../scss/vars' as *;

.payments-f2-disclaimer {
    margin: 5px;
    margin-bottom: 10px;
    color: $danger;
}
</style>
